module.exports = __webpack_public_path__ + "img/first_testimonial.ac812dec.jpeg";